import { PreviousPrompt } from "@mirage/service-compute-relevance/service/types";
import { atom } from "jotai";

export const recentPromptsAtom = atom<PreviousPrompt[]>([]);

export const selectedPromptIdAtom = atom<string | null>(null);
